<template>
	<header class="media-lightbox-toolbar px-4 py-2" data-test-id="media-lightbox-toolbar">
		<div class="media-lightbox-toolbar__leading"><slot name="leading" /></div>
		<div class="media-lightbox-toolbar__actions"><slot name="actions" /></div>
		<div class="media-lightbox-toolbar__trailing">
			<slot name="close">
				<!-- Admin's lightbox close (MediaLightBox.vue), mr-2 inset included. -->
				<v-btn
					:aria-label="closeLabel ?? 'Close gallery'"
					class="mr-2"
					icon
					size="small"
					color="black"
					variant="flat"
					elevation="0"
					@click="emit('close')">
					<v-icon>icon-close-medium</v-icon>
				</v-btn>
			</slot>
		</div>
	</header>
</template>

<script setup lang="ts">
	/** The close button's accessible name: say what it does (async's viewer X returns to its grid, LSP-22456). */
	defineProps<{ closeLabel?: string }>();
	const emit = defineEmits<{ close: [] }>();
</script>

<style scoped>
	.media-lightbox-toolbar {
		display: grid;
		grid-template-columns: minmax(0, 1fr) minmax(0, auto) minmax(0, 1fr);
		align-items: center;
		min-height: 4.5rem;
		background: #f5f6f9;
		color: #000;
	}
	/* Admin's button typography for every toolbar button, slotted ones included (it sizes their icons too). */
	.media-lightbox-toolbar :deep(.v-btn) {
		font-family: Inter;
		font-size: 0.875rem;
		font-weight: 600;
		letter-spacing: normal;
		text-transform: none;
	}
	/* The label sits in .v-btn__content, which async's base.css `*` reset sets to normal weight. */
	.media-lightbox-toolbar :deep(.v-btn__content) {
		font-weight: inherit;
	}
	.media-lightbox-toolbar__leading {
		justify-self: start;
	}
	.media-lightbox-toolbar__actions {
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: 0;
		gap: 0.25rem;
	}
	.media-lightbox-toolbar__trailing {
		justify-self: end;
	}
	/* Narrow (async only; admin's mobile lightbox has its own controls): the X keeps the first row and the actions take
	   their own row under it, centred on the photo below; auto margins centre them, so a row wider than the screen
	   scrolls from its start instead of clipping it. */
	@media (max-width: 959px) {
		.media-lightbox-toolbar {
			grid-template-columns: minmax(0, 1fr) auto;
			gap: 0.25rem;
		}
		.media-lightbox-toolbar__leading {
			display: none;
		}
		.media-lightbox-toolbar__actions {
			grid-column: 1 / -1;
			grid-row: 2;
			overflow-x: auto;
			justify-content: flex-start;
		}
		.media-lightbox-toolbar__actions > :deep(*) {
			margin-inline: auto;
		}
		.media-lightbox-toolbar__trailing {
			grid-column: 2;
			grid-row: 1;
		}
	}
</style>
